export default "__VITE_ASSET__Vuovts7j__"